const timeDifference = 10;

// ActiveX setup
function getConfigChecker() {
    var object = document.getElementById('CfgChecker');
    if (!object) {
        object = document.createElement('object');
        object.id = 'CfgChecker';
        object.classid = 'clsid:A3D1D649-86FE-4DAB-8365-A1B51E3C6571';
        object.width = '0';
        object.height = '0';
        document.body.appendChild(object);
        return document.getElementById('CfgChecker');
    }
    return object;
}

// Get Internet Explorer Settings
export function checkTimeZone(){
    return getConfigChecker().IsPCOnTime(timeDifference);
    // Checks for discrepancy between the client and the server within a threshold
    // 1 : The client time zone is valid
    // 0 : The client time zone is invalid
    //-1 : The check could not be achieved
}

export function checkIsabelDomainStatus(){
    return getConfigChecker().IsIsabelInTrustedSites()
    // In 'Internet Options', under 'Security' tab, it returns whether the Isabel domain is in the 'Trusted sites' list
    // 1 : The Isabel domain is defined as a trusted site
    // 0 : The Isabel domain is not defined as a trusted site
    //-1 : The check could not be achieved
}